import { render, staticRenderFns } from "./EditGoogleFontOptions.vue?vue&type=template&id=a5d5c604"
import script from "./EditGoogleFontOptions.vue?vue&type=script&lang=js"
export * from "./EditGoogleFontOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports